import request from "@/axios.js";
import store from "../store/store";

export default class Society {
	/**
	 * Society class
	 * @param {object} society - Object society
	 * @property {string} phone - a phone.
	 * @property {number} status - an status.
	 * @property {string} name - a name.
	 * @property {string} adress - an adress.
	 * @property {string} adress_complement - an adress complement.
	 * @property {string} country - a country.
	 * @property {string} country_id - a country id.
	 * @property {string} city - a city.
	 * @property {number} postal_code - a postal_code.
	 * @property {string} tva - a tva.
	 * @property {string} website - a website.
	 * @property {number} origin - an origin.
	 * @property {string} siret - a siret.
	 * @property {Array<string>} topkeywords - list of top keywords
	 * @property {number} is_ecommerce - 0 if not 1 if e commerce
	 * @property {string} gsc_url - google search console URL
	 * @property {number} analytics_id - ID from analytics
	 * @property {string} robotxt_url - URL of the robot.txt of a website
	 * @property {Array<string>} sorted_keyword_position - List of position of keyword
	 * @property {Array<string>} georanker_keyword_data - Data from georanker api (keywords)
	 * @property {number} dataforseo_id - ID of a request from dataForSeo API
	 * @property {Array<string>} georanker_serp_data - Data from georanker API (SERP)
	 * @property {Array<object>} urls_from_sitemap - All urls retrieved from a sitemap
	 * @property {number} commercial_id - ID of the commercial in charge of the contract
	 * @property {string} image - Link to the image of the society
	 * @property {number} tva_id - TVA dashboard ID for invoicing
	 * @property {number} term_id - ID of the payment term of the society
	 * @property {number} google_ads_mcc - ID of the google mcc account
	 */
	constructor(society) {
		this.phone = society.phone;
		this.status = society.status || 0;
		this.name = society.name;
		this.adress = society.adress;
		this.adress_complement = society.adress_complement;
		this.country = society.country;
		this.country_id = society.country_id;
		this.city = society.city;
		this.postal_code = society.postal_code;
		this.tva = society.tva;
		this.website = society.website;
		this.origin = society.origin;
		this.topkeywords = society.topkeywords;
		this.is_ecommerce = society.is_ecommerce;
		this.gsc_url = society.gsc_url;
		this.analytics_id = society.analytics_id;
		this.robotxt_url = society.robotxt_url;
		this.siret = society.siret;
		this.sorted_keyword_position = society.sorted_keyword_position;
		this.georanker_keyword_data = society.georanker_keyword_data;
		this.dataforseo_id = society.dataforseo_id;
		this.georanker_serp_data = society.georanker_serp_data;
		this.urls_from_sitemap = society.urls_from_sitemap;
		this.commercial_id = society.commercial_id;
		this.creation_timestamp = society.creation_timestamp;
		this.last_update_timestamp = society.last_update_timestamp;
		this.image = society.image;
		this.img_link = society.img_link;
		this.activity_domain = [];
		this.tva_id = society.tva_id;
		this.term_id = society.term_id;
		this.language_id = society.language_id;
		this.currency_id = society.currency_id;
		this.google_ads_mcc = society.google_ads_mcc;
		this.export_to_big_query = society.export_to_big_query || 0;
	}

	/**
	 * Create an object to be used for forms (on creation)
	 * @return {object} society object
	 */
	static getFormFields(){
		return {
			phone: null,
			status: 0,
			name: null,
			adress: null,
			adress_complement: null,
			country: null,
			city: null,
			postal_code: null,
			tva: null,
			website: null,
			origin: null,
			topkeywords: null,
			is_ecommerce: null,
			gsc_url: null,
			analytics_id: null,
			robotxt_url: null,
			siret: null,
			sorted_keyword_position: null,
			georanker_keyword_data: null,
			georanker_serp_data: null,
			dataforseo_id: null,
			urls_from_sitemap: null,
			commercial_id: null,
			image: null,
			img_link: null,
			activity_domain: [],
			term_id: 6,
			tva_id: 1,
			country_id: null,
			language_id: 1,
			currency_id: 1,
			google_ads_mcc: null,
			export_to_big_query: 0,
		};
	}

	/**
	 * Request to update all fields of a society
	 * @param {number} id - ID of the society to update
	 * @param {function} callback - Callback function
	 */
	update(id, callback) {
		//console.log("update from Society object front: " + id);
		let param = {
			society: this,
			id: id
		};
		let re = new RegExp("([T|Z])", "g");
		param.society.creation_timestamp = param.society.creation_timestamp.replace(re, " ");
		param.society.last_update_timestamp = param.society.last_update_timestamp.replace(re, " ");
		// For some strange reason without the timeout the param magically modify itself (urls_from_sitemap not being send correctly)

				request
					.post("society/update", param)
					.then(result => callback(null, result))
					.catch(err => callback(err, null));

	}

	compare(societyToCompare){
		for(let key in societyToCompare) {
			if(this[key] != societyToCompare[key]){
				return false;
			}
		}
		return true;
	}
	/**
	 * Request to delete a society
	 * @param {number} id - ID of the society to delete
	 */
	static delete(id) {
		request.delete("society/delete", {
			id: id
		});
	}

	static getAllSocities(callback) {
		request.get("society/all")
			.then((res) => callback(null, res))
			.catch((err) => callback(err, null));
	}
	/**
	 * Fetch all languages
	 * @returns {Promise}
	 */
	static getLanguages() {
		return new Promise((resolve, reject) => {
			request.get("others/languages")
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	/**
	 * Fetch Google Ads datas
	 * @param {Array} societyIds - [1,2,3]
	 * @param {String} period - MM/YYYY
	 * @returns 
	 */
	static fetchGoogleAds(societyIds, period) {
		return new Promise((resolve, reject) => {
			let emptyGoogleAds = [];
			let responseGoogleAds = [];
			// Get stored google ads
			let storedGoogleAds = store.state.googleAds;

			// Check if stored google ads are
			if(storedGoogleAds.length > 0){
				for(let societyId of societyIds){
					let foundSoc = storedGoogleAds.find(soc => soc.societyId == societyId && soc.period == period);
					if(foundSoc){
						responseGoogleAds.push(foundSoc);
					}else{
						emptyGoogleAds.push(societyId);
					}
			}
			}
			else {
				emptyGoogleAds = societyIds;
			}
		// If no stored google ads
		if(emptyGoogleAds.length != 0){

			request.post("ads/spent_amount_societies/period", {
				period,
				societyIds: emptyGoogleAds,
			})
				.then((res) => {
					responseGoogleAds = responseGoogleAds.concat(res.data);
					store.dispatch("setGoogleAds", responseGoogleAds);
					resolve(responseGoogleAds);
				})
				.catch((err) => {
					reject(err);
				});
			}else{
				resolve(responseGoogleAds);
			}
		});
	}
	/**
	 * Get all top keywords for a society
	 * @param {Number} id 
	 * @returns 
	 */
	static getTopKeywords(id) {
		return new Promise((resolve, reject) => {
			request.get("society/getTopKeywords/" + id)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	static getCompetitors(id) {
		return new Promise((resolve, reject) => {
			request.get("society/getCompetitors/" + id)
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
	// Brands
	static async getCompetitors(id) {
			return new Promise((resolve, reject) => {
				request.get("society/getCompetitors/" + id)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
	static async addCompetitors(data, id){
			return new Promise((resolve, reject) => {
				request.post("society/addCompetitors/" + id, data)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
	static async updateCompetitor(data, id){
			return new Promise((resolve, reject) => {
				request.patch("society/competitors/" + id, data)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
	static async deleteCompetitors(id){
			return new Promise((resolve, reject) => {
				request.delete("society/competitors/" + id)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
	static async deleteBatchCompetitors(ids){
			return new Promise((resolve, reject) => {
				request.post("society/competitors/delete_batch/", ids)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
		// Brands
		static async getBrands(id) {
			return new Promise((resolve, reject) => {
				request.get("society/getBrands/" + id)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
		static async updateBrand(data, id){
			return new Promise((resolve, reject) => {
				request.patch("society/brands/" + id, data)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
	static async addBrands(data, id){
			return new Promise((resolve, reject) => {
				request.post("society/addBrands/" + id, data)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
	static async deleteBrands(id){
			return new Promise((resolve, reject) => {
				request.delete("society/brands/" + id)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
	static async deleteBrandByName(brand, id){
			return new Promise((resolve, reject) => {
				request.delete(`society/brandByName?socId=${id}&brand=${brand}`)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
	static async deleteBatchBrands(ids){
			return new Promise((resolve, reject) => {
				request.post("society/brands/delete_batch/", ids)
					.then((res) => {
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
}
